import React, { useEffect, useState } from 'react'
import { Row, Card, Form, Input, Radio, Space, Button, Col, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import { sendEmailForExpressPolicyChanges } from '../services'
import { DRIVER_JSON_MAP } from './ChangeAddressConstants'

import ChangeAddressStyle from '../../styles/ChangeAddress.module.css'
import { NoIndex } from './NoIndex'

const { Text } = Typography

const ChangeAddress = () => {
  useEffect(() => {
    window.location.href = "/404";
  }, []);
  
  return null;

  const [driver, setDriver] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    zipCode: '',
    emailAddress: '',
    changeAddress: {
      streetAddress: '',
      apt: '',
      city: '',
      state: '',
      zipCode: '',
      effectDate: '',
      dateOfChange: '',
      isVehiclesStayOvernight: '',
      vehiclesStayOvernightAddress: {
        streetAddress: '',
        apt: '',
        city: '',
        state: '',
        zipCode: ''
      },
      memberChangeAddress: ''
    }
  })
  const [disableButton, setDisableButton] = useState(false)

  const validateBasicFormData = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      changeAddress: {
        streetAddress: changedStreetAddress,
        city,
        state,
        zipCode: changedZipCode,
        effectDate,
        dateOfChange,
        isVehiclesStayOvernight,
        vehiclesStayOvernightAddress: {
          streetAddress: overnightStayStreetAddress,
          city: overnightCity,
          state: overnightState,
          zipCode: overnightZipCode
        },
        memberChangeAddress
      }
    } = driverInfo

    if (
      firstName &&
      lastName &&
      policyNumber &&
      phoneNumber &&
      streetAddress &&
      zipCode &&
      emailAddress &&
      changedStreetAddress &&
      city &&
      state &&
      changedZipCode &&
      effectDate &&
      dateOfChange &&
      isVehiclesStayOvernight &&
      memberChangeAddress
    ) {
      if (isVehiclesStayOvernight === 'No') {
        if (overnightStayStreetAddress && overnightCity && overnightState && overnightZipCode) {
          return { isValid: true }
        } else {
          return { isValid: false }
        }
      } else {
        return { isValid: true }
      }
    } else {
      return { isValid: false }
    }
  }

  const validateDate = driverInfo => {
    const {
      changeAddress: { dateOfChange, effectDate }
    } = driverInfo

    if (new Date(effectDate).toString() === 'Invalid Date' || new Date(dateOfChange).toString() === 'Invalid Date') {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateEmail = driverInfo => {
    const { emailAddress } = driverInfo
    const regEx = /\S+@\S+\.\S+/

    if (emailAddress.length > 0 && regEx.test(emailAddress)) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const validateZipCode = driverInfo => {
    const { zipCode } = driverInfo

    if (zipCode.length < 5) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const formatPhoneNumber = phoneNumber => {
    const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
  }

  const validatePhoneNumber = driverInfo => {
    const { phoneNumber } = driverInfo
    const updatedNumber = phoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
    if (formatPhoneNumber(updatedNumber).length < 10) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateFields = driverInfo => {
    let validationResponse = true
    const initialResponse = validateBasicFormData(driverInfo)
    if (initialResponse.isValid) {
      const dateValidationResponse = validateDate(driverInfo)
      const zipCodeValidationResponse = validateZipCode(driverInfo)
      const phoneValidationResponse = validatePhoneNumber(driverInfo)
      const emailValidationResponse = validateEmail(driverInfo)
      if (
        dateValidationResponse.isValid &&
        zipCodeValidationResponse.isValid &&
        phoneValidationResponse.isValid &&
        emailValidationResponse.isValid
      ) {
        validationResponse = true
      } else {
        validationResponse = false
      }
    } else {
      validationResponse = false
    }
    return validationResponse
  }

  const stripFinalJson = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      changeAddress: {
        streetAddress: changedStreetAddress,
        apt,
        city,
        state,
        zipCode: changedZipCode,
        effectDate,
        dateOfChange,
        isVehiclesStayOvernight,
        vehiclesStayOvernightAddress: {
          streetAddress: overnightStayStreetAddress,
          apt: overnightApt,
          city: overnightCity,
          state: overnightState,
          zipCode: overnightZipCode
        },
        memberChangeAddress
      }
    } = driverInfo
    const obj = {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      changeAddress: {
        streetAddress: changedStreetAddress,
        apt,
        city,
        state,
        zipCode: changedZipCode,
        dateOfChange,
        isVehiclesStayOvernight,
        ...(isVehiclesStayOvernight === 'No' && {
          vehiclesStayOvernightAddress: {
            streetAddress: overnightStayStreetAddress,
            apt: overnightApt,
            city: overnightCity,
            state: overnightState,
            zipCode: overnightZipCode
          }
        }),
        memberChangeAddress,
        effectDate
      }
    }
    return obj
  }

  const buildTable = driverInfo => {
    var table = '<table border="1">'
    table += '<tr><td colspan="2"><b>Policyholder Information</b></td></tr>'
    for (const key in driverInfo) {
      if (driverInfo[key] instanceof Object) {
        table += '<tr><td colspan="2"><b>New Address Information</b></td></tr>'
        for (const additionalKey in driverInfo[key]) {
          if (driverInfo[key][additionalKey] instanceof Object) {
            table += '<tr><td colspan="2"><b>Vehicles overnight new address</b></td></tr>'
            for (const addressKey in driverInfo[key][additionalKey]) {
              table += `<tr><td>${DRIVER_JSON_MAP[key][additionalKey][addressKey]}</td><td>${driverInfo[key][additionalKey][addressKey]}</td></tr>`
            }
          } else {
            table += `<tr><td>${DRIVER_JSON_MAP[key][additionalKey]}</td><td>${driverInfo[key][additionalKey]}</td></tr>`
          }
        }
      } else {
        table += `<tr><td>${DRIVER_JSON_MAP[key]}</td><td>${driverInfo[key]}</td></tr>`
      }
    }
    table += '</table>'
    return table
  }

  const handleSubmit = async () => {
    setDisableButton(true)
    const finalJson = stripFinalJson(driver)
    const htmlText = buildTable(finalJson)
    const mailObj = {
      subject: `[Change of Address] - ${driver.policyNumber}`,
      content: htmlText
    }
    localStorage.setItem('expressPolicyChangeType', 'Change Address')

    await sendEmailForExpressPolicyChanges(mailObj)

    const newWindow = window.open('/g/express-policy-changes/result', '_self', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const updateUserTextFields = (text, field) => {
    const clonedUser = { ...driver }
    clonedUser[field] = text
    setDriver(clonedUser)
  }

  const buttonStatus = !validateFields(driver) || disableButton

  return (
    <div className="container">
      <NoIndex/>
      <GlobalHeader />
      <>
        <EmptyHeaderHero minHeight={true} title="Change Address" />
        <div className={`${ChangeAddressStyle["change-address"]}`}>
          <p className={`${ChangeAddressStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
          <Row>
            <Card className={`${ChangeAddressStyle["register-card"]}`}>
              <h5 className={`${ChangeAddressStyle["sub-label"]}`}>Policyholder Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${ChangeAddressStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                      placeholder="First Name*"
                      value={driver.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${ChangeAddressStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                      placeholder="Last Name*"
                      value={driver.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${ChangeAddressStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                      placeholder="Policy Number*"
                      value={driver.policyNumber}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${ChangeAddressStyle["input-text"]} ${ChangeAddressStyle["phone-number"]}`}
                      mask="(999) 999-9999"
                      onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                      placeholder="Phone Number*"
                      value={driver.phoneNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${ChangeAddressStyle["input-text"]}`}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          streetAddress: event.target.value
                        })
                      }}
                      placeholder="Street Address*"
                      value={driver.streetAddress}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${ChangeAddressStyle["input-text"]}`}
                      maxLength={5}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          zipCode: event.target.value.replace(/\D/g, '')
                        })
                      }}
                      placeholder="Zip Code*"
                      value={driver.zipCode}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${ChangeAddressStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                      placeholder="Email Address*"
                      value={driver.emailAddress}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <h5 className={`${ChangeAddressStyle["sub-label"]}`}>New Address Information</h5>
              <>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${ChangeAddressStyle["input-text"]}`}
                        onChange={event => {
                          const changeAddress = {
                            ...driver.changeAddress
                          }
                          changeAddress.streetAddress = event.target.value
                          setDriver({
                            ...driver,
                            changeAddress
                          })
                        }}
                        placeholder="Street Address*"
                        value={driver.changeAddress.streetAddress}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${ChangeAddressStyle["input-text"]}`}
                        onChange={event => {
                          const changeAddress = {
                            ...driver.changeAddress
                          }
                          changeAddress.apt = event.target.value
                          setDriver({
                            ...driver,
                            changeAddress
                          })
                        }}
                        placeholder="Apartment#"
                        value={driver.changeAddress.apt}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${ChangeAddressStyle["input-text"]}`}
                        onChange={event => {
                          const changeAddress = {
                            ...driver.changeAddress
                          }
                          changeAddress.city = event.target.value
                          setDriver({
                            ...driver,
                            changeAddress
                          })
                        }}
                        placeholder="City*"
                        value={driver.changeAddress.city}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${ChangeAddressStyle["input-text"]}`}
                        onChange={event => {
                          const changeAddress = {
                            ...driver.changeAddress
                          }
                          changeAddress.state = event.target.value
                          setDriver({
                            ...driver,
                            changeAddress
                          })
                        }}
                        placeholder="State*"
                        value={driver.changeAddress.state}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${ChangeAddressStyle["input-text"]}`}
                        maxLength={5}
                        onChange={event => {
                          const changeAddress = {
                            ...driver.changeAddress
                          }
                          changeAddress.zipCode = event.target.value.replace(/\D/g, '')
                          setDriver({
                            ...driver,
                            changeAddress
                          })
                        }}
                        placeholder="Zip Code*"
                        value={driver.changeAddress.zipCode}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
              <Text className={`${ChangeAddressStyle["form-effect-label"]}`}>When did/will you move to this address?*</Text>
              <Row>
                <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                  <InputMask
                    className={`${ChangeAddressStyle["dob"]}`}
                    mask="99/99/9999"
                    onChange={event => {
                      const changeAddress = {
                        ...driver.changeAddress
                      }
                      changeAddress.dateOfChange = event.target.value
                      setDriver({
                        ...driver,
                        changeAddress
                      })
                    }}
                    placeholder="mm/dd/yyyy*"
                    value={driver.changeAddress.dateOfChange}
                  />
                </Col>
              </Row>
              <Text className={`${ChangeAddressStyle["form-label"]} ${ChangeAddressStyle["form-effect-label"]} ${ChangeAddressStyle["margin-bottom-0"]} ${ChangeAddressStyle["margin-top-12"]}`}>
                Will all your vehicles be kept overnight at this new address?*
              </Text>
              <Row>
                <Col xl={{ span: 14 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Radio.Group
                      onChange={event => {
                        const changeAddress = {
                          ...driver.changeAddress,
                          isVehiclesStayOvernight: event.target.value
                        }
                        setDriver({
                          ...driver,
                          changeAddress
                        })
                      }}
                      value={driver.changeAddress.isVehiclesStayOvernight}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {driver.changeAddress.isVehiclesStayOvernight === 'No' && (
                <>
                  <Text className={`${ChangeAddressStyle["form-effect-label"]}`}>Street Address:</Text>
                  <Row>
                    <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                      <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${ChangeAddressStyle["input-text"]}`}
                          onChange={event => {
                            const changeAddress = {
                              ...driver.changeAddress
                            }
                            changeAddress.vehiclesStayOvernightAddress.streetAddress = event.target.value
                            setDriver({
                              ...driver,
                              changeAddress
                            })
                          }}
                          placeholder="Street Address*"
                          value={driver.changeAddress.vehiclesStayOvernightAddress.streetAddress}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${ChangeAddressStyle["input-text"]}`}
                          onChange={event => {
                            const changeAddress = {
                              ...driver.changeAddress
                            }
                            changeAddress.vehiclesStayOvernightAddress.apt = event.target.value
                            setDriver({
                              ...driver,
                              changeAddress
                            })
                          }}
                          placeholder="Apartment#"
                          value={driver.changeAddress.vehiclesStayOvernightAddress.apt}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                      <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${ChangeAddressStyle["input-text"]}`}
                          onChange={event => {
                            const changeAddress = {
                              ...driver.changeAddress
                            }
                            changeAddress.vehiclesStayOvernightAddress.city = event.target.value
                            setDriver({
                              ...driver,
                              changeAddress
                            })
                          }}
                          placeholder="City*"
                          value={driver.changeAddress.vehiclesStayOvernightAddress.city}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${ChangeAddressStyle["input-text"]}`}
                          onChange={event => {
                            const changeAddress = {
                              ...driver.changeAddress
                            }
                            changeAddress.vehiclesStayOvernightAddress.state = event.target.value
                            setDriver({
                              ...driver,
                              changeAddress
                            })
                          }}
                          placeholder="State*"
                          value={driver.changeAddress.vehiclesStayOvernightAddress.state}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${ChangeAddressStyle["input-text"]}`}
                          maxLength={5}
                          onChange={event => {
                            const changeAddress = {
                              ...driver.changeAddress
                            }
                            changeAddress.vehiclesStayOvernightAddress.zipCode = event.target.value.replace(/\D/g, '')
                            setDriver({
                              ...driver,
                              changeAddress
                            })
                          }}
                          placeholder="Zip Code*"
                          value={driver.changeAddress.vehiclesStayOvernightAddress.zipCode}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              <Text className={`${ChangeAddressStyle["form-effect-label"]}`}>Will your household members change at the new address?*</Text>
              <Row>
                <Col xl={{ span: 14 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <Radio.Group
                      onChange={event => {
                        const changeAddress = {
                          ...driver.changeAddress,
                          memberChangeAddress: event.target.value
                        }
                        setDriver({
                          ...driver,
                          changeAddress
                        })
                      }}
                      value={driver.changeAddress.memberChangeAddress}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Text className={`${ChangeAddressStyle["form-effect-label"]}`}>What date would you like this change to go into effect?*</Text>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${ChangeAddressStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${ChangeAddressStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        const changeAddress = {
                          ...driver.changeAddress
                        }
                        changeAddress.effectDate = event.target.value
                        setDriver({
                          ...driver,
                          changeAddress
                        })
                      }}
                      placeholder="mm/dd/yyyy*"
                      value={driver.changeAddress.effectDate}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Row>
          <Row className={`${ChangeAddressStyle["submit-container"]}`}>
            <Form.Item className={`${ChangeAddressStyle["btn-control"]} ${ChangeAddressStyle["button-submit-form"]}`}>
              <Space>
                <Button className={`${ChangeAddressStyle["register"]} ${ChangeAddressStyle["register-form-button"]}`} disabled={buttonStatus} onClick={handleSubmit}>
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

ChangeAddress.propTypes = {}

export default ChangeAddress
